import { useState, useEffect, useRef } from 'react';
import { LuBell } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import NotificationItem from './NotificationItem';
import { useAuth } from '../../contexts/AuthContext';

export default function NotificationDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 30000); // Refresh every 30s
      return () => clearInterval(interval);
    }
  }, [user]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchNotifications = async () => {
    if (!user?.id) return;
    try {
      const { data, error } = await window.ezsite.apis.tablePage(70655, {
        PageNo: 1,
        PageSize: 10,
        OrderByField: 'created_at',
        IsAsc: false,
        Filters: [{ name: 'user_id', op: 'Equal', value: Number(user.id) }]
      });

      if (error) {
        console.error('Failed to fetch notifications:', error);
        return;
      }

      if (data?.List) {
        setNotifications(data.List);
        setUnreadCount(data.List.filter((n) => !n.is_read).length);
      }
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    }
  };

  const handleNotificationClick = async (notification) => {
    try {
      // Mark as read
      if (!notification.is_read) {
        const { error } = await window.ezsite.apis.tableUpdate(70655, {
          id: Number(notification.id),
          is_read: true
        });
        if (error) {
          console.error('Failed to mark notification as read:', error);
        }
      }

      // Navigate to link
      if (notification.link) {
        navigate(notification.link);
      }

      setIsOpen(false);
      fetchNotifications();
    } catch (error) {
      console.error('Failed to handle notification:', error);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 hover:bg-gray-100 rounded-lg transition">

        <LuBell className="w-6 h-6 text-gray-700" />
        {unreadCount > 0 &&
        <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        }
      </button>

      {isOpen &&
      <div className="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-[500px] flex flex-col">
          <div className="p-4 border-b border-gray-200 flex items-center justify-between">
            <h3 className="font-semibold text-gray-900">Notifications</h3>
            {unreadCount > 0 &&
          <span className="text-sm text-blue-600 font-medium">
                {unreadCount} unread
              </span>
          }
          </div>
          
          <div className="overflow-y-auto flex-1">
            {notifications.length === 0 ?
          <div className="p-8 text-center text-gray-500">
                <LuBell className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                <p>No notifications yet</p>
              </div> :

          notifications.map((notification) =>
          <NotificationItem
            key={notification.id}
            notification={notification}
            onClick={() => handleNotificationClick(notification)} />

          )
          }
          </div>
          
          {notifications.length > 0 &&
        <div className="p-3 border-t border-gray-200">
              <button
            onClick={() => {
              navigate('/notifications');
              setIsOpen(false);
            }}
            className="w-full text-center text-sm text-blue-600 hover:text-blue-700 font-medium">

                View All Notifications
              </button>
            </div>
        }
        </div>
      }
    </div>);

}